import React from 'react';
import {Text, StyleSheet} from 'react-native';
import {Styles} from "./constants";
 

const boldFont =   Styles.segoeUiBold;

const textComponent = (props) => {
   
    const{
        fontFamily,
        size,
        H1,
        H2,
        H3,
        H4,
        H5,
        Color,
        dark,
        light,
        primary,
        secondary,
        white,
        P,
        title,
        style,
        bold
    } = props;



  return(
      <Text 
      {...props}    
      style={[styles.defaultStyle, {fontFamily: bold ? boldFont : Styles.primaryFontFamily},style]}
      >
     {props.children}
      </Text>
  )
}

const styles = StyleSheet.create({
    defaultStyle: {
        // fontSize:12,
        // color:'#848484',
         fontFamily:Styles.primaryFontFamily,
         
         
    }
})



export default textComponent;